import { VaultDetails } from '../store/vaults';
import { utils, BigNumber } from 'ethers';

export function parseVaultDetails(vault: VaultDetails): VaultDetails {
  return {
    id: utils.getAddress(vault.id),
    address: utils.getAddress(vault.address),
    name: vault.name,
    blockCreated: Number(vault.blockCreated),
    feeTier: Number(vault.feeTier),
    liquidity: BigNumber.from(vault.liquidity),
    lowerTick: Number(vault.lowerTick),
    upperTick: Number(vault.upperTick),
    manager: vault.manager,
    managerFee: vault.managerFee,
    positionId: vault.positionId,
    token0: {
      ...vault.token0,
      decimals: Number(vault.token0.decimals),
    },
    token1: {
      ...vault.token1,
      decimals: Number(vault.token1.decimals),
    },
    tokenPrice0: vault.tokenPrice0,
    tokenPrice1: vault.tokenPrice1,
    totalSupply: BigNumber.from(vault.totalSupply),
    uniswapPool: vault.uniswapPool,
    tvl: vault.tvl,
    apr: vault.apr,
    aprTimestamp: vault.aprTimestamp,
    feesEarned0: BigNumber.from(vault.feesEarned0),
    feesEarned1: BigNumber.from(vault.feesEarned1),
    balance: BigNumber.from(vault.balance),
    reserves0: BigNumber.from(vault.reserves0),
    reserves1: BigNumber.from(vault.reserves0),
    share0: BigNumber.from(vault.share0),
    share1: BigNumber.from(vault.share1),
    reward: BigNumber.from(vault.reward),
    rewardTokenPrice: Number(vault.rewardTokenPrice),
    rewardTimestamp: Number(vault.rewardTimestamp),
  };
}
